export default __webpack_public_path__ + "static/media/Rakesh Ramakrishnan.1e5f02af.jpg";